<template>
    <div>
        <base-table
            hide-default-footer
            v-bind="$attrs"
            v-on="$listeners"
            :headers="processedHeaders"
            :items="processedItems"
            :options="options"
            @click:row="onClickRowItem"
        >
            <template v-slot:[`item.action`]="{ item }">
                <div
                    class="action-button mx-1 grey--text text--darken-2 rounded clickable"
                    @click="$emit('edit', item)">
                    <icon
                        value="edit"
                        size="18px"/>
                </div>
            </template>
        </base-table>
    </div>
</template>

<script>
import BaseTable from '@/components/tables/BaseTable'
import ExcludableTable from '@/mixins/ExcludableTable'

export default {
    name: 'CustomerGroupTable',

    components: {
        BaseTable
    },

    mixins: [ExcludableTable],

    props: {
        items: {
            type: Array,
            default: () => []
        },

        options: {
            type: Object,
            default: () => ({})
        }
    },

    data () {
        return {
            headers: [
                {
                    text: this.$t('customerGroupList.table.header.id'),
                    value: this.$constant.table.CUSTOMER_GROUP_KEY.id,
                    width: '135px',
                    sortable: false
                },
                {
                    text: this.$t('customerGroupList.table.header.name'),
                    value: this.$constant.table.CUSTOMER_GROUP_KEY.name,
                    sortable: false
                },
                {
                    text: this.$t('customerGroupList.table.header.contact'),
                    value: this.$constant.table.CUSTOMER_GROUP_KEY.contact,
                    width: '180px',
                    sortable: false
                },
                {
                    text: this.$t('customerGroupList.table.header.phone'),
                    value: this.$constant.table.CUSTOMER_GROUP_KEY.phone,
                    width: '150px',
                    sortable: false
                },
                {
                    text: '',
                    value: 'action',
                    width: '60px',
                    sortable: false
                }
            ]
        }
    },

    computed: {
        processedItems () {
            return this.items.map((item) => ({
                ...item,
                contactName: item.contact.name,
                contactPhone: item.contact.phone
            }))
        }
    },

    methods: {
        onClickRowItem (item) {
            this.$emit('viewDetails', item)
        }
    }
}
</script>

<style lang="scss" scoped></style>
